import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
    Table, TableBody, TableContainer, TableHead, TableRow, IconButton, Tooltip, Paper, TablePagination,
    Box
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import { disableAdmin } from "../../../services/adminServices/AdminServices";
import BlockIcon from "@mui/icons-material/Block";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
        fontSize: 16,
        fontWeight: 600
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        textTransform: "capitalize",

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const AdminTable = ({ rows, onEditClick, getAllUsersData, search = "" }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    React.useEffect(() => {
        setPage(0);
    }, [search]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const searchLower = (search || "").toLowerCase();
    const filteredRows = (rows || []).filter((row) => {
        if (!searchLower) return true;
        
        const searchRecursive = (obj) => {
            if (!obj) return false;
            return Object.values(obj).some(value => {
                if (value === null || value === undefined) return false;
                if (typeof value === 'object') return searchRecursive(value);
                return String(value).toLowerCase().includes(searchLower);
            });
        };
        
        return searchRecursive(row);
    });

    const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    function highlightText(text, search) {
        if (!search || !text) return text;
        const textStr = String(text);
        const parts = textStr.split(new RegExp(`(${search})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === search.toLowerCase() ? <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span> : part
        );
    }
    const disableCoe = async (id) => {
        try {
            const response = await disableAdmin(id);
            toast.success(response.data.message);
            getAllUsersData();
        } catch (error) {
            toast.error(error?.response?.data.message || error?.message || error?.error);
        }
    }
    return (
        <Box sx={{ width: "100%" }}>
            <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
                <Table sx={{ tableLayout: "auto", width: "max-content", minWidth: "100%" }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Email</StyledTableCell>
                        <StyledTableCell>Role</StyledTableCell>
                        <StyledTableCell>Mobile</StyledTableCell>
                        <StyledTableCell>Action</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginatedRows?.map((row, index) => {
                        return (
                            <StyledTableRow key={index}>
                                <StyledTableCell>{highlightText(row.display_name, search) || "-"}</StyledTableCell>
                                <StyledTableCell sx={{ textTransform: "initial !important" }}>{highlightText(row.email, search) || "-"}</StyledTableCell>
                                <StyledTableCell>
                                    {row.role
                                        ? highlightText(row.role
                                            .split("_")
                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                            .join(" "), search)
                                        : "-"}
                                </StyledTableCell>
                                <StyledTableCell>{highlightText(row.mobile_number, search) || "-"}</StyledTableCell>
                                <StyledTableCell>
                                    <Tooltip title="Edit" arrow>
                                        <IconButton size="small" aria-label="edit" onClick={() => onEditClick(row)}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    {/* <Tooltip
                                        title="Disable"
                                        arrow
                                        onClick={() => disableCoe(row.ejet_admin_id)}
                                    >
                                        <IconButton size="small" aria-label="disable">
                                            <BlockIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip> */}
                                </StyledTableCell>
                            </StyledTableRow>
                        );
                    })}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[10,20,30,60,100]}
                component="div"
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </TableContainer>
        </Box>
    );
};

export default AdminTable;
